import React, { memo, useState, useEffect } from 'react';
import { Button, Flex } from '@chakra-ui/react';
import useEventBus from 'hooks/useEventBus';
import { PageTitle } from './styles';
import { ProfileMenu } from './ProfileMenu';
import { useHistory } from 'react-router-dom';
import { CustomIcon } from 'components';

export const TopbarComponent: React.FC = () => {
  const history = useHistory();
  const [title, setTitle] = useState('Início');
  const eventBus = useEventBus();
  const isHome = history.location.pathname === '/home';
  const params = history.location.pathname;

  useEffect(() => {
    const onChangeTitle = (title: string) => {
      setTitle(title || '');
    };

    eventBus.addEventListener('onChangeTitle', onChangeTitle);

    return () => eventBus.addEventListener('onChangeTitle', onChangeTitle);
  }, []);

  return (
    <Flex
      height="72px"
      backgroundColor="brand.white"
      justifyContent="space-between"
      alignItems="center"
      px="32px"
    >
      <PageTitle>
        {!isHome && (
          <Button
            display={params === '/functions' ? 'none' : 'flex'}
            // border="1px solid red"
            onClick={() => {
              const path = localStorage.getItem('goBack') as string;
              if (history.location.pathname === '/budgetControl') {
                history.push(path);
                return;
              }
              history.goBack();
            }}
            bgColor="transparent"
            _hover={{ bg: 'transparent' }}
            p="0"
            margin="0"
            _active={{ borderStyle: 'outset' }}
            cursor={params === '/functions' ? 'default' : 'pointer'}
          >
            {params !== '/functions' && <CustomIcon icon="arrow_left" size="16px" $noSphere />}{' '}
          </Button>
        )}
        {title}
      </PageTitle>

      <ProfileMenu />
    </Flex>
  );
};
export const Topbar = memo(TopbarComponent);
